import { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  DeleteFilled,
  EditFilled,
  PlusCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';

import { Button, Card, Col, Input, Row, Table } from 'antd';

import { userCompanyListMappingHeader as columns } from '@/utils/tableHeader';
// import { ConfirmModal } from '@/components'

//  api
import { handleDeleteApi } from '@/api/crud';
import { userCompanyMappingApiEndpoints } from '@/api/endpoints';
import { useFetch } from '@/hooks';

import { enablePaginationOrNot } from '@/utils/common';
import { globalSearch } from '@/utils/search/Search';

import GlobalModal from '@/utils/modal/Modal';

/**
 * roles list component
 * @returns
 */

const UserCompanyMappingList = () => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  //   const [form] = Form.useForm()

  const { data, isLoading, isSuccess, refresh } = useFetch(
    userCompanyMappingApiEndpoints.retrieveList,
  );

  const handleCancel = () => {
    setOpenDeleteModal(false);
    // form.resetFields()
    setReferenceId(null);
  };

  const handleOpenDeleteModal = (id) => {
    setReferenceId(id);
    setOpenDeleteModal(true);
  };

  const handleDeleteOk = () => {
    setOpenDeleteModal(false);
    handleDeleteApi(
      referenceId,
      userCompanyMappingApiEndpoints.delete,
      setLoading,
      refresh,
    );
  };

  return (
    <>
      {/*  branch crud modals */}
      {/* delete  modal */}
      {/* <ConfirmModal
        open={openDeleteModal}
        handleOk={handleDeleteOk}
        handleCancel={handleCancel}
      /> */}

      <GlobalModal
        isVisible={openDeleteModal}
        onConfirm={handleDeleteOk}
        onClose={handleCancel}
        type="delete"
      />

      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant='outlined'
              title={
                <Link to="/user/company/mapping/create/">
                  <Button className="centered" size="medium" type="primary">
                    <PlusCircleOutlined />
                    Create
                  </Button>
                </Link>
              }
              extra={
                <div className="flex flex-col items-center justify-center gap-[10px]">
                  <Input
                    className="header-search"
                    name="query"
                    placeholder="Search Role..."
                    value={searchQuery}
                    prefix={<SearchOutlined />}
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />
                </div>
              }
            >
              <div className="overflow-x-auto">
                <Table
                  size="large"
                  bordered
                  loading={isLoading || loading}
                  columns={columns}
                  className="ant-border-space"
                  style={{ textAlign: 'center', padding: '15px' }}
                  pagination={!isLoading ? enablePaginationOrNot(data) : false}
                  dataSource={
                    isSuccess
                      ? globalSearch(data, searchQuery)?.map((user, index) => {
                          return {
                            key: user.userId,
                            index: index + 1,
                            company: user.company,
                            username: user.username,
                            phone: user.mobileNumber,
                            action: (
                              <div className="flex justify-center items-center gap-1">
                                <div className="ant-button-edit">
                                  <Link
                                    size="medium"
                                    className="edit"
                                    to={`${user.userId}/edit/`}
                                  >
                                    <EditFilled className="text-blue-300" />
                                  </Link>
                                </div>
                                <div className="ant-button-delete">
                                  <Link
                                    size="medium"
                                    className="text-danger"
                                    onClick={() =>
                                      handleOpenDeleteModal(user.userId)
                                    }
                                  >
                                    <DeleteFilled />
                                  </Link>{' '}
                                </div>
                              </div>
                            ),
                          };
                        })
                      : []
                  }
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default UserCompanyMappingList;
